import { DatePipe } from '@angular/common'
import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'
import * as stores from '../stores'

import * as aiBanner from './ai-banner'
import * as titleEditor from './title-editor'

/**
 * Detail of a single note in Summit Archive
 */
@ngCore.Component({
  imports: [
    ds.input.richTextEditor.Component,
    ds.illustration.emptyState.Component,
    ds.button.Component,
    titleEditor.Component,
    aiBanner.Component,
    DatePipe,
  ],
  selector: 'atn-summit-archive-detail',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.archive.Collection}  */
  public readonly archiveEc = ngCore.inject(state.summit.archive.Collection)
  /** @see {@link LayoutStore}  */
  public readonly layoutStore = ngCore.inject(stores.Layout)
  /** @see {@link state.summit.archive.assistants.summarize.Feature} */
  // public readonly summarizeAssistant = ngCore.inject(
  //   state.summit.archive.assistants.summarize.Feature,
  // )
}
